export interface Collectible {
  id: string;
  slug: string;
  name: string;
  tier: "Common" | "Mystery" | "Rare" | "Epic" | "Legendary" | "Immortal";
  cardClass: string;
  unitPrice: number;
  unitVcoin: number;
  powerMult: number;
  powerUses: number;
  totalSupply: number;
  remainingSupply: number;
  supplyDays: number;
  images: string[];
  isMystery: boolean;
  tag?: "Most Popular" | "Best Value";
  isActive: boolean;
  productId?: number;
}

export interface TierAccent {
  accent: string;
  accent2: string;
  glow: string;
  line: string;
}

export const TIER_ACCENTS: Record<string, TierAccent> = {
  Common:    { accent: "#f5c842", accent2: "#fff0ad", glow: "rgba(245,200,66,.30)", line: "rgba(245,200,66,.22)" },
  Mystery:   { accent: "#7cecff", accent2: "#e0fdff", glow: "rgba(124,236,255,.26)", line: "rgba(124,236,255,.22)" },
  Rare:      { accent: "#ffae46", accent2: "#ffe7c4", glow: "rgba(255,174,70,.26)", line: "rgba(255,174,70,.22)" },
  Epic:      { accent: "#c896ff", accent2: "#efe0ff", glow: "rgba(200,150,255,.26)", line: "rgba(200,150,255,.22)" },
  Legendary: { accent: "#8cefd0", accent2: "#e6fff6", glow: "rgba(140,239,208,.26)", line: "rgba(140,239,208,.22)" },
  Immortal:  { accent: "#ffe18d", accent2: "#fff7d0", glow: "rgba(255,225,141,.26)", line: "rgba(255,225,141,.22)" },
};

export const STAGE_REWARDS = [100, 90, 85, 75, 65, 60, 50, 45, 40, 30, 25, 20, 15, 10, 5];
